export default "__VITE_ASSET__CCa__9Ka__"